import { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../../common/components/ui/loading/ButtonLoading";
import { validateCustomerNetrin } from "../../../../../common/services/netrin.api";
import { getIn, useFormikContext } from "formik";

type FormPropsValidationNetrin = {
  entityId: string
  entityName: string
  cpf: string
  validCPF: boolean
  status: boolean
  validated: boolean
};

export default function NetrinActivate(props: FormPropsValidationNetrin) {
  const { notifySuccess, notifyError } = useToastContext()
  const [bindNetrinInProgress, setBindNetrinInProgress] = useState(false)
  const [shouldDeactivate, setShouldDeactivate] = useState(true)

  const { setFieldValue, values } = useFormikContext()

  const { entityId, entityName } = props

  const jurValidation: FormPropsValidationNetrin = getIn(values, 'jurValidation')

  async function handleValidateNetrin() {
    try {
      setBindNetrinInProgress(true)
      const { cpf } = props;
      const cleanedCPF = cpf.replace(/[.-]/g, '');
      const result = await validateCustomerNetrin(cleanedCPF, entityId, entityName)

      if (!result.ok) {
        notifyError("Erro ao validar juridicamente o cliente")
        return
      }

      if (result.data.jurValidation.status) {
        notifySuccess("Validação concluída!")
        setFieldValue(`jurValidation.status`, true)
        setFieldValue(`jurValidation.validated`, true)
        setShouldDeactivate(true)
      } else {
        notifyError("O cliente não foi aprovado na análise jurídica")
        setFieldValue(`jurValidation.status`, false)
        setFieldValue(`jurValidation.validated`, true)
        setShouldDeactivate(true)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setBindNetrinInProgress(false)
    }
  }

  useEffect(() => {
    // Verifica se o botão deve ser desabilitado ou habilitado e em que ocasião
    // Ele deve ser desabilitado sempre que o CPF for inválido, e se for válido mas
    // já estiver sido acionado uma vez, desabilitar o botão.
    // Só habilitar o botão de novo se atendente apagar o campo de CPF
    // (cpf.length === 0 e jurValidated set to false) e digitar o CPF válido novamente inteiro

    if (props.cpf.length === 0) setFieldValue(`jurValidation.validated`, false)

    if (props.validCPF && !jurValidation.validated) setShouldDeactivate(false)

    if (!props.validCPF) setShouldDeactivate(true)

  }, [props.validCPF, bindNetrinInProgress, jurValidation.validated, props.cpf, setFieldValue])

  return (
    <div className="flex flex-col gap-4">

      <div className="flex w-full justify-between items-center">
        <div>
          <h2 className="font-semibold ">Clique aqui para validar juridicamente o cliente:</h2>
        </div>
        {/* <div>
          <ButtonWithLoader
            type="button"
            disabled={shouldDeactivate}
            isLoading={bindNetrinInProgress} onClick={handleValidateNetrin}>
            Validar Juridicamente
          </ButtonWithLoader>
          {
            jurValidation.validated === false ? (
              <></>
            ) : jurValidation.status ? (
              <FaCheckCircle size={24} className='text-green' />
            ) : (
              <FaTimesCircle size={24} className='text-red' />
            )
          }

        </div> */}
      </div>


      <div className="flex w-full justify-between items-center">
        <div>
          <h2 className="font-semibold ">Clique aqui para validar CNH</h2>
        </div>
        {/* <div>
          <ButtonWithLoader
            type="button"
            disabled={!jurValidation.status}
          >
            Validar CNH
          </ButtonWithLoader>
        </div> */}
        <div className="grid-div2">
          <ButtonWithLoader
            type="button"
            disabled={shouldDeactivate}
            isLoading={bindNetrinInProgress} onClick={handleValidateNetrin}>
            Validar Juridicamente
          </ButtonWithLoader>
          {
            jurValidation.validated === false ? (
              <></>
            ) : jurValidation.status ? (
              <FaCheckCircle size={24} className='text-greenPrimary' />
            ) : (
              <FaTimesCircle size={24} className='text-redPrimary' />
            )
          }
        </div>
      </div>
    </div>
  )
}
